"use strict";

const angular = require("angular");

angular.module("Finance").factory("$user", [
  "$oidc",
  function(oidc) {
    var user = {
      get isAuthenticated() {
        return typeof oidc.current !== "undefined" && oidc.current !== null;
      },
      get name() {
        return this.isAuthenticated ? oidc.current.user_info.name : null;
      },
      get loginName() {
        return this.isAuthenticated ? oidc.current.user_info.user_login : null;
      },
      get retailerId() {
        return this.isAuthenticated ? oidc.current.user_info.dealer_id : null;
      },
      get isOnBehalfOfDealers() {
        return (
          this.isAuthenticated &&
          oidc.current.user_info.role.includes("onBehalfOfDealers")
        );
      },
      get isPartyEditor() {
        return (
          this.isAuthenticated &&
          oidc.current.user_info.role.includes("party_Editor")
        );
      },
      get isAuditor() {
        return (
          this.isAuthenticated &&
          oidc.current.user_info.role.includes("auditor")
        );
      },
      get isExtendedWarrantyInvoiceReader() {
        return (
          this.isAuthenticated &&
          oidc.current.user_info.role.includes("extendedWarrantyInvoice_Reader")
        );
      },
      get isPartsInvoiceReader() {
        return (
          this.isAuthenticated &&
          oidc.current.user_info.role.includes("partsInvoice_Reader")
        );
      },
      get isSalesInvoiceReader() {
        return (
          this.isAuthenticated &&
          oidc.current.user_info.role.includes("salesInvoice_Reader")
        );
      },
      get isWarrantyInvoiceReader() {
        return (
          this.isAuthenticated &&
          oidc.current.user_info.role.includes("warrantyInvoice_Reader")
        );
      },
      get isInvoiceReader() {
        return (
          this.isExtendedWarrantyInvoiceReader ||
          this.isPartsInvoiceReader ||
          this.isSalesInvoiceReader ||
          this.isWarrantyInvoiceReader
        );
      }
    };
    return user;
  }
]);
